module.exports = __webpack_public_path__ + "static/media/default-coin.3ed58189.svg";